<template>
  <label class="item" v-bind:class="classByValue" v-bind:title="title">
    <input type="button" v-on:click="onClick" />
    <span>{{ name }}</span>
  </label>
</template>

<script>

/**
 * @description Добавлено.
 * @type {string}
 */
const ADDITIONAL = 'additional';

/**
 * @description По позиции.
 * @type {string}
 */
const BY_POSITION = 'by-positions';

/**
 * @description Исключено.
 * @type {string}
 */
const EXCLUDED = 'excluded';

/**
 * @description Компонент разрешения сотрудника.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Текст при наведении.
     * @type {string}
     */
    title() {
      switch (this.value) {
        case ADDITIONAL: return 'Добавлено';
        case EXCLUDED: return 'Исключено';
        default: return '';
      }
    },
    /**
     * @description Класс по значению.
     * @type {string}
     */
    classByValue() {
      if (this.value === BY_POSITION && this.isContains) {
        return 'selected';
      }
      return this.value;
    },
  },
  methods: {
    /**
     * @description Обработать нажатие.
     * @returns {void}
     */
    onClick() {
      const nextValue = (current) => {
        switch (current) {
          case BY_POSITION: return this.isContains ? EXCLUDED : ADDITIONAL;
          case ADDITIONAL: return this.isContains ? BY_POSITION : BY_POSITION;
          case EXCLUDED: return this.isContains ? BY_POSITION : ADDITIONAL;
          default: return BY_POSITION;
        }
      };
      this.$emit('input', nextValue(this.value));
    },
  },
  name: 'PermissionItem',
  props: {
    /**
     * @description Содержит.
     * @type {string}
     */
    isContains: { type: Boolean, required: true },
    /**
     * @description Название.
     * @type {string}
     */
    name: { type: String, required: true },
    /**
     * @description Значение.
     * @type {string}
     */
    value: { type: String, required: true },
  },
};
</script>

<style scoped>
.item>input {
  opacity: 0;
  position: absolute;
  z-index: -1;
}
.item>input:focus+span::before {
  border-color: var(--action-color);
}
.item>span {
  align-items: center;
  display: inline-flex;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  user-select: none;
  cursor: pointer;
}
.item>span::before {
  background-color: var(--primary-background-color);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 70%;
  border: 1px solid var(--unfocus-color);
  border-radius: 4px;
  content: '';
  display: inline-block;
  flex-grow: 0;
  flex-shrink: 0;
  height: 1.5rem;
  margin: 0 10px 0 0;
  width: 1.5rem;
}
.additional>span::before {
  background-color: var(--action-color);
  border: 1px solid var(--action-color);
  background-image: url("@/assets/img/checked/checked-white-top.svg");
}
.excluded>span::before {
  background-color: var(--primary-background-color);
  background-image: none;
}
.selected>span::before {
  background-color: var(--unfocus-color);
  border: 1px solid var(--unfocus-color);
  background-image: url("@/assets/img/checked/checked-white-top.svg");
}
.selected>input:focus+span::before {
  border-color: black;
}
.unselected>span::before{
  background-color: var(--primary-background-color);
  background-image: none;
}
</style>
